import { CanvasBaseObject } from '../../domain/content-control/canvas';

export class ShapeCollection<T extends CanvasBaseObject> {
  private _items: T[] = [];

  constructor(
    private _postIngestFn?: (existing: T, incoming: T) => void,
  ) {}

  add(item: T): boolean {
    if (this._items.findIndex((x) => x.id === item.id) === -1) {
      this._items.push(item);
      return true;
    }
    return false;
  }

  update(item: T): void {
    const existing = this._items.find((x) => x.id === item.id);
    if (existing) {
      existing.ingest(item);
      this._postIngestFn?.(existing, item);
    } else {
      this.add(item);
    }
  }

  remove(id: number): boolean {
    const index = this._items.findIndex((x) => x.id === id);
    if (index > -1) {
      this._items.splice(index, 1);
      return true;
    }
    return false;
  }

  clear(): void {
    this._items = [];
  }

  get items(): ReadonlyArray<T> {
    return this._items;
  }

  get length(): number {
    return this._items.length;
  }
}
